module.exports = __webpack_public_path__ + "static/media/resume_redirection.aa8c23a8.png";